import { __extends } from "tslib";
import { _GraphQueryable } from "./graphqueryable";
import { setup as _setup, } from "./graphlibconfig";
import { GraphBatch } from "./batch";
var GraphRest = /** @class */ (function (_super) {
    __extends(GraphRest, _super);
    function GraphRest() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GraphRest.prototype.createBatch = function () {
        return new GraphBatch();
    };
    GraphRest.prototype.setup = function (config) {
        if (config.pageContext) {
            _setup({
                spfxContext: config,
            });
        }
        else {
            _setup(config);
        }
    };
    return GraphRest;
}(_GraphQueryable));
export { GraphRest };
export var graph = new GraphRest("v1.0");
//# sourceMappingURL=rest.js.map